import { makeStyles } from '@material-ui/core'
import { colors } from '../../Themes'

const ManualFileUploadStyles = makeStyles((theme) => ({
  drop: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px dashed #314155',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '32px',
    gap: 10,
    [theme.breakpoints.down(600)]: {
      padding: '32px 15px',
    },
        
  },
  dropDragging: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    border: '1px dashed #314155',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '32px',
    gap: 10,
    background: 'rgba(49, 65, 85, 0.05)',
    [theme.breakpoints.down(600)]: {
      padding: '32px 15px',
    },
        
  },
  uploadWithErrors: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    width: '100%'
  },
  fileUploaded: {
    // width: '100%',
    display: 'flex',
    border: '1px solid #cecece',
    borderRadius: 5,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '20px 32px 20px 16px',
    gap: 10,
    position: 'relative',
    width: 496,
    [theme.breakpoints.down(760)]: {
      padding: '20px 15px',
      width: '93%'
    },
    [theme.breakpoints.down(500)]: {
      padding: '20px 15px',
      width: '91%'
    },
    [theme.breakpoints.down(400)]: {
      padding: '20px 15px',
      width: '90%'
    },
    [theme.breakpoints.down(360)]: {
      padding: '20px 15px',
      width: '88%'
    },
        
  },
  afterDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 0px',
    gap: 10,
    [theme.breakpoints.down(400)]: {
      padding: '20px 15px',
    },
  },
  textUpload: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  text: {
    display: 'flex',
    flexDirection: 'column', 
    textAlign: 'center',
    gap: 10
  },
  done: {
    display: 'flex',
    gap: 10
  },
  buttonDiv: {
    display: 'flex', 
    justifyContent: 'flex-end', 
    alignItems: 'center',
    gap: 10,
    paddingTop: 10,
    [theme.breakpoints.down(600)]: {
      justifyContent: 'center',
      flexDirection: 'column'
    },
  },
  button: {
    width: 220,
    [theme.breakpoints.down(600)]: {
      width: '100%'
    },
  },
  cancel: {
    width: 220,
    background: colors.white,
    color: colors.primary,
    border: `1px solid ${colors.primary}`,
    [theme.breakpoints.down(600)]: {
      width: '100%'
    },
    '&:hover': {
      background: colors.white,
      color: colors.primary,
      border: `1px solid ${colors.primary}`,
    },
  },
  errorICon: {
    paddingRight: 10,
  },
  error: {
    display: 'flex',
    alignItems: 'center'
  },
  forMobile: {
    display: 'flex',
    gap: 10, 
    alignItems: 'center',
    [theme.breakpoints.down(760)]: {
      flexDirection: 'column',
      alignItems: 'start',
      gap: 5, 
     
    },
  },
  iconButtonClose: {
    position: 'absolute',
    top: 5,
    right: 5,
    fill: 'red',
    [theme.breakpoints.down(500)]: {
      top: 2,
      right: 2,
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column', 
    gap: 20, 
    width: '100%' 
  },
  formItems: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    width: '100%'
  },
  fileInfoContainer: {
    display: 'flex',
    gap: 24, 
    justifyContent: 'start', 
    width: '100%', 
    alignItems: 'center' 
  },
  fileImg: {
    objectFit: 'contain', 
    height: 32,
    width: 32
  }
}))

const useStyles = makeStyles((theme) => ({
  root: {
    width: '75%',
    borderRadius: 29, 
    background: '#D9D9D9',
    position: 'absolute',
    bottom: 35,
    left: 85,
    '& .MuiLinearProgress-bar': {
      backgroundColor: 'linear-gradient(90deg, #901F5D 0%, rgba(238, 67, 82, 0.97) 98.67%)'
    },
    [theme.breakpoints.down(1200)]: {
      width: '80%'
    },
    [theme.breakpoints.down(1000)]: {
      width: '70%'
    },
    [theme.breakpoints.down(760)]: {
      width: '80%'
    },
    [theme.breakpoints.down(630)]: {
      width: '75%'
    },
    [theme.breakpoints.down(600)]: {
      width: '75%',
      left: 68,
    },
    [theme.breakpoints.down(500)]: {
      width: '70%'
    },
    [theme.breakpoints.down(400)]: {
      width: '65%'
    },
  },
}))

export  { ManualFileUploadStyles, useStyles }